'use client'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import services from '../services'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { GetTaskHypothesisRecommendationsParams } from '@/shared/api/end-points/hypothesis'
import { HypothesisRecommendation } from '../services/get-task-recommendations'

const useHook = (params: GetTaskHypothesisRecommendationsParams) => {
  const queryKey = [queryKeys((a, m, p) => a.hypothesis.getTaskHypothesisRecommendations(params) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getTaskRecommendations(params)),
    refetchOnWindowFocus: false,
  })

  const queryResult = {
    ...query,
    queryKey,
    data: query?.data || [],
  }

  return queryResult as UseQueryResult<HypothesisRecommendation[]>
}
export default useHook
